if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{

						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {

				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".product-page-tabs")) return;

  const productPage = document.querySelector("product-page");
  if (!productPage) return;

  const mainSection = productPage.closest('[id^="shopify-section-"]');
  if (!mainSection) return;

  const parent = mainSection.parentNode;
  if (!parent) return;

  const allSections = Array.from(parent.children).filter((el) => {
    return el.id && el.id.startsWith("shopify-section-");
  });

  const mainIndex = allSections.indexOf(mainSection);
  if (mainIndex === -1) return;

  let sectionsAfterProduct = allSections.slice(mainIndex + 1);

  sectionsAfterProduct = sectionsAfterProduct.filter((section) => {
    if (section.id.includes("content_toggles")) return false; // enlève FAQ
    return true;
  });

  sectionsAfterProduct.sort((a, b) => {
  const order = (section) => {

    // Choisissez votre déclinaison en premier
    if (section.innerText.includes("Choisissez votre déclinaison")) return 1;

    // Produits complémentaires en deuxième
    if (section.id.includes("product-recommendations")) return 2;

    // Blog
    if (section.id.includes("blog_posts")) return 3;

    // Avis
    if (section.innerText.includes("Avis Clients")) return 4;

    return 99;
  };

  return order(a) - order(b);
});

  if (!sectionsAfterProduct.length) return;

  const tabsWrapper = document.createElement("section");
  tabsWrapper.className = "product-page-tabs";

  const tabsNav = document.createElement("div");
  tabsNav.className = "product-page-tabs__nav";

  const indicator = document.createElement("div");
  indicator.className = "product-page-tabs__indicator";
  tabsNav.appendChild(indicator);

  const tabsPanels = document.createElement("div");
  tabsPanels.className = "product-page-tabs__panels";

  const buttons = [];
  const panels = [];

  function getSectionLabel(section, index) {
    if (section.id.includes("product-recommendations")) return "Produits complémentaires";
    if (section.id.includes("blog_posts")) return "Articles de Blog";
    if (section.innerText.includes("Avis Clients")) return "Avis Clients";

    const heading =
      section.querySelector(".section-heading__title") ||
      section.querySelector(".section-heading h2") ||
      section.querySelector(".section-heading h3") ||
      section.querySelector("h2") ||
      section.querySelector("h3");

    if (heading && heading.textContent.trim()) {
      return heading.textContent.trim();
    }

    return `Onglet ${index + 1}`;
  }

  function moveIndicator(activeButton) {
    if (!activeButton) return;

    const left = activeButton.offsetLeft;
    const width = activeButton.getBoundingClientRect().width;

    indicator.style.width = `${width}px`;
    indicator.style.transform = `translateX(${left}px)`;
  }

  function activateTab(index) {
    buttons.forEach((button, i) => {
      button.classList.toggle("is-active", i === index);
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle("is-active", i === index);
    });

    moveIndicator(buttons[index]);
  }

  sectionsAfterProduct.forEach((section, index) => {
    const label = getSectionLabel(section, index);

    const button = document.createElement("button");
    button.className = "product-page-tabs__btn";
    button.type = "button";
    button.textContent = label;

    const panel = document.createElement("div");
    panel.className = "product-page-tabs__panel";
    panel.appendChild(section);

    button.addEventListener("click", () => activateTab(index));

    tabsNav.appendChild(button);
    tabsPanels.appendChild(panel);

    buttons.push(button);
    panels.push(panel);
  });

  tabsWrapper.appendChild(tabsNav);
  tabsWrapper.appendChild(tabsPanels);

  mainSection.insertAdjacentElement("afterend", tabsWrapper);

  activateTab(0);

  window.addEventListener("resize", () => {
    const activeButton = tabsNav.querySelector(".product-page-tabs__btn.is-active");
    moveIndicator(activeButton);
  });
});